var appFooter = {
  templateUrl: './app-footer.html'
}

angular
  .module('common')
  .component('appFooter', appFooter)
